// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/requestcatalog/v1/requestcatalogmanagement.proto" (package "c1.api.requestcatalog.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { RequestCatalogOwnersService } from "./requestcatalogmanagement";
import type { RequestCatalogOwnersServiceRemoveResponse } from "./requestcatalogmanagement";
import type { RequestCatalogOwnersServiceRemoveRequest } from "./requestcatalogmanagement";
import type { RequestCatalogOwnersServiceAddResponse } from "./requestcatalogmanagement";
import type { RequestCatalogOwnersServiceAddRequest } from "./requestcatalogmanagement";
import type { RequestCatalogOwnersServiceListResponse } from "./requestcatalogmanagement";
import type { RequestCatalogOwnersServiceListRequest } from "./requestcatalogmanagement";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { RequestCatalogManagementService } from "./requestcatalogmanagement";
import type { CreateAppDefaultCatalogRequest } from "./requestcatalogmanagement";
import type { DeleteBundleAutomationResponse } from "./requestcatalogmanagement";
import type { DeleteBundleAutomationRequest } from "./requestcatalogmanagement";
import type { CreateBundleAutomationRequest } from "./requestcatalogmanagement";
import type { ResumePausedBundleAutomationResponse } from "./requestcatalogmanagement";
import type { ResumePausedBundleAutomationRequest } from "./requestcatalogmanagement";
import type { ForceRunBundleAutomationResponse } from "./requestcatalogmanagement";
import type { ForceRunBundleAutomationRequest } from "./requestcatalogmanagement";
import type { SetBundleAutomationRequest } from "./requestcatalogmanagement";
import type { BulkGetBundleAutomationsResponse } from "./requestcatalogmanagement";
import type { BulkGetBundleAutomationsRequest } from "./requestcatalogmanagement";
import type { BundleAutomation } from "./requestcatalogmanagement";
import type { GetBundleAutomationRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceDeleteResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceDeleteRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceListEntitlementsForAccessResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceListEntitlementsForAccessRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceUpdateAppEntitlementsResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceUpdateAppEntitlementsRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceListEntitlementsPerAppResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceListEntitlementsPerAppRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceListEntitlementsPerCatalogResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceListEntitlementsPerCatalogRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceRemoveAccessEntitlementsResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceRemoveAccessEntitlementsRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceAddAccessEntitlementsResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceAddAccessEntitlementsRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceDeleteRequestableEntryResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceDeleteRequestableEntryRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceGetRequestableEntryResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceGetRequestableEntryRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceCreateRequestableEntryResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceCreateRequestableEntryRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceRemoveAppEntitlementsResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceRemoveAppEntitlementsRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceAddAppEntitlementsResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceAddAppEntitlementsRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceListResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceListRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceUpdateRequest } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceCreateRequest } from "./requestcatalogmanagement";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { RequestCatalogManagementServiceGetResponse } from "./requestcatalogmanagement";
import type { RequestCatalogManagementServiceGetRequest } from "./requestcatalogmanagement";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.requestcatalog.v1.RequestCatalogManagementService
 */
export interface IRequestCatalogManagementServiceClient {
    /**
     * Get a catalog.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: RequestCatalogManagementServiceGetRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceGetRequest, RequestCatalogManagementServiceGetResponse>;
    /**
     * Creates a new request catalog.
     *
     * @generated from protobuf rpc: Create
     */
    create(input: RequestCatalogManagementServiceCreateRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceCreateRequest, RequestCatalogManagementServiceGetResponse>;
    /**
     * Update a catalog.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: RequestCatalogManagementServiceUpdateRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceUpdateRequest, RequestCatalogManagementServiceGetResponse>;
    /**
     * Get a list of request catalogs.
     *
     * @generated from protobuf rpc: List
     */
    list(input: RequestCatalogManagementServiceListRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceListRequest, RequestCatalogManagementServiceListResponse>;
    /**
     * Add requestable entitlements to a catalog.
     *
     * @generated from protobuf rpc: AddAppEntitlements
     */
    addAppEntitlements(input: RequestCatalogManagementServiceAddAppEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceAddAppEntitlementsRequest, RequestCatalogManagementServiceAddAppEntitlementsResponse>;
    /**
     * Remove requestable entitlements from a catalog.
     *
     * @generated from protobuf rpc: RemoveAppEntitlements
     */
    removeAppEntitlements(input: RequestCatalogManagementServiceRemoveAppEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceRemoveAppEntitlementsRequest, RequestCatalogManagementServiceRemoveAppEntitlementsResponse>;
    // Individual Requestable Entry Management RPCs

    /**
     * Create a single requestable entry
     *
     * @generated from protobuf rpc: CreateRequestableEntry
     */
    createRequestableEntry(input: RequestCatalogManagementServiceCreateRequestableEntryRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceCreateRequestableEntryRequest, RequestCatalogManagementServiceCreateRequestableEntryResponse>;
    /**
     * Get a single requestable entry
     *
     * @generated from protobuf rpc: GetRequestableEntry
     */
    getRequestableEntry(input: RequestCatalogManagementServiceGetRequestableEntryRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceGetRequestableEntryRequest, RequestCatalogManagementServiceGetRequestableEntryResponse>;
    /**
     * Delete a single requestable entry
     *
     * @generated from protobuf rpc: DeleteRequestableEntry
     */
    deleteRequestableEntry(input: RequestCatalogManagementServiceDeleteRequestableEntryRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceDeleteRequestableEntryRequest, RequestCatalogManagementServiceDeleteRequestableEntryResponse>;
    /**
     * Add visibility bindings (access entitlements) to a catalog.
     *
     * @generated from protobuf rpc: AddAccessEntitlements
     */
    addAccessEntitlements(input: RequestCatalogManagementServiceAddAccessEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceAddAccessEntitlementsRequest, RequestCatalogManagementServiceAddAccessEntitlementsResponse>;
    /**
     * Remove visibility bindings (access entitlements) to a catalog.
     *
     * @generated from protobuf rpc: RemoveAccessEntitlements
     */
    removeAccessEntitlements(input: RequestCatalogManagementServiceRemoveAccessEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceRemoveAccessEntitlementsRequest, RequestCatalogManagementServiceRemoveAccessEntitlementsResponse>;
    /**
     * List entitlements in a catalog that are requestable.
     *
     * @generated from protobuf rpc: ListEntitlementsPerCatalog
     */
    listEntitlementsPerCatalog(input: RequestCatalogManagementServiceListEntitlementsPerCatalogRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceListEntitlementsPerCatalogRequest, RequestCatalogManagementServiceListEntitlementsPerCatalogResponse>;
    /**
     * @generated from protobuf rpc: ListEntitlementsPerApp
     */
    listEntitlementsPerApp(input: RequestCatalogManagementServiceListEntitlementsPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceListEntitlementsPerAppRequest, RequestCatalogManagementServiceListEntitlementsPerAppResponse>;
    /**
     * @generated from protobuf rpc: ListAllEntitlementIdsPerApp
     */
    listAllEntitlementIdsPerApp(input: RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest, RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse>;
    /**
     * @generated from protobuf rpc: UpdateAppEntitlements
     */
    updateAppEntitlements(input: RequestCatalogManagementServiceUpdateAppEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceUpdateAppEntitlementsRequest, RequestCatalogManagementServiceUpdateAppEntitlementsResponse>;
    /**
     * List visibility bindings (access entitlements) for a catalog.
     *
     * @generated from protobuf rpc: ListEntitlementsForAccess
     */
    listEntitlementsForAccess(input: RequestCatalogManagementServiceListEntitlementsForAccessRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceListEntitlementsForAccessRequest, RequestCatalogManagementServiceListEntitlementsForAccessResponse>;
    /**
     * Delete a catalog.
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: RequestCatalogManagementServiceDeleteRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceDeleteRequest, RequestCatalogManagementServiceDeleteResponse>;
    /**
     * Get bundle automation
     *
     * @generated from protobuf rpc: GetBundleAutomation
     */
    getBundleAutomation(input: GetBundleAutomationRequest, options?: RpcOptions): UnaryCall<GetBundleAutomationRequest, BundleAutomation>;
    /**
     * Bulk get bundle automations
     *
     * @generated from protobuf rpc: BulkGetBundleAutomations
     */
    bulkGetBundleAutomations(input: BulkGetBundleAutomationsRequest, options?: RpcOptions): UnaryCall<BulkGetBundleAutomationsRequest, BulkGetBundleAutomationsResponse>;
    /**
     * @generated from protobuf rpc: SetBundleAutomation
     */
    setBundleAutomation(input: SetBundleAutomationRequest, options?: RpcOptions): UnaryCall<SetBundleAutomationRequest, BundleAutomation>;
    /**
     * @generated from protobuf rpc: ForceRunBundleAutomation
     */
    forceRunBundleAutomation(input: ForceRunBundleAutomationRequest, options?: RpcOptions): UnaryCall<ForceRunBundleAutomationRequest, ForceRunBundleAutomationResponse>;
    /**
     * @generated from protobuf rpc: ResumePausedBundleAutomation
     */
    resumePausedBundleAutomation(input: ResumePausedBundleAutomationRequest, options?: RpcOptions): UnaryCall<ResumePausedBundleAutomationRequest, ResumePausedBundleAutomationResponse>;
    /**
     * @generated from protobuf rpc: CreateBundleAutomation
     */
    createBundleAutomation(input: CreateBundleAutomationRequest, options?: RpcOptions): UnaryCall<CreateBundleAutomationRequest, BundleAutomation>;
    /**
     * @generated from protobuf rpc: DeleteBundleAutomation
     */
    deleteBundleAutomation(input: DeleteBundleAutomationRequest, options?: RpcOptions): UnaryCall<DeleteBundleAutomationRequest, DeleteBundleAutomationResponse>;
    /**
     * @generated from protobuf rpc: CreateAppDefaultCatalog
     */
    createAppDefaultCatalog(input: CreateAppDefaultCatalogRequest, options?: RpcOptions): UnaryCall<CreateAppDefaultCatalogRequest, RequestCatalogManagementServiceGetResponse>;
}
/**
 * @generated from protobuf service c1.api.requestcatalog.v1.RequestCatalogManagementService
 */
export class RequestCatalogManagementServiceClient implements IRequestCatalogManagementServiceClient, ServiceInfo {
    typeName = RequestCatalogManagementService.typeName;
    methods = RequestCatalogManagementService.methods;
    options = RequestCatalogManagementService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Get a catalog.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: RequestCatalogManagementServiceGetRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceGetRequest, RequestCatalogManagementServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceGetRequest, RequestCatalogManagementServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Creates a new request catalog.
     *
     * @generated from protobuf rpc: Create
     */
    create(input: RequestCatalogManagementServiceCreateRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceCreateRequest, RequestCatalogManagementServiceGetResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceCreateRequest, RequestCatalogManagementServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update a catalog.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: RequestCatalogManagementServiceUpdateRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceUpdateRequest, RequestCatalogManagementServiceGetResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceUpdateRequest, RequestCatalogManagementServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a list of request catalogs.
     *
     * @generated from protobuf rpc: List
     */
    list(input: RequestCatalogManagementServiceListRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceListRequest, RequestCatalogManagementServiceListResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceListRequest, RequestCatalogManagementServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Add requestable entitlements to a catalog.
     *
     * @generated from protobuf rpc: AddAppEntitlements
     */
    addAppEntitlements(input: RequestCatalogManagementServiceAddAppEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceAddAppEntitlementsRequest, RequestCatalogManagementServiceAddAppEntitlementsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceAddAppEntitlementsRequest, RequestCatalogManagementServiceAddAppEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Remove requestable entitlements from a catalog.
     *
     * @generated from protobuf rpc: RemoveAppEntitlements
     */
    removeAppEntitlements(input: RequestCatalogManagementServiceRemoveAppEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceRemoveAppEntitlementsRequest, RequestCatalogManagementServiceRemoveAppEntitlementsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceRemoveAppEntitlementsRequest, RequestCatalogManagementServiceRemoveAppEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    // Individual Requestable Entry Management RPCs

    /**
     * Create a single requestable entry
     *
     * @generated from protobuf rpc: CreateRequestableEntry
     */
    createRequestableEntry(input: RequestCatalogManagementServiceCreateRequestableEntryRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceCreateRequestableEntryRequest, RequestCatalogManagementServiceCreateRequestableEntryResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceCreateRequestableEntryRequest, RequestCatalogManagementServiceCreateRequestableEntryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a single requestable entry
     *
     * @generated from protobuf rpc: GetRequestableEntry
     */
    getRequestableEntry(input: RequestCatalogManagementServiceGetRequestableEntryRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceGetRequestableEntryRequest, RequestCatalogManagementServiceGetRequestableEntryResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceGetRequestableEntryRequest, RequestCatalogManagementServiceGetRequestableEntryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a single requestable entry
     *
     * @generated from protobuf rpc: DeleteRequestableEntry
     */
    deleteRequestableEntry(input: RequestCatalogManagementServiceDeleteRequestableEntryRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceDeleteRequestableEntryRequest, RequestCatalogManagementServiceDeleteRequestableEntryResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceDeleteRequestableEntryRequest, RequestCatalogManagementServiceDeleteRequestableEntryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Add visibility bindings (access entitlements) to a catalog.
     *
     * @generated from protobuf rpc: AddAccessEntitlements
     */
    addAccessEntitlements(input: RequestCatalogManagementServiceAddAccessEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceAddAccessEntitlementsRequest, RequestCatalogManagementServiceAddAccessEntitlementsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceAddAccessEntitlementsRequest, RequestCatalogManagementServiceAddAccessEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Remove visibility bindings (access entitlements) to a catalog.
     *
     * @generated from protobuf rpc: RemoveAccessEntitlements
     */
    removeAccessEntitlements(input: RequestCatalogManagementServiceRemoveAccessEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceRemoveAccessEntitlementsRequest, RequestCatalogManagementServiceRemoveAccessEntitlementsResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceRemoveAccessEntitlementsRequest, RequestCatalogManagementServiceRemoveAccessEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List entitlements in a catalog that are requestable.
     *
     * @generated from protobuf rpc: ListEntitlementsPerCatalog
     */
    listEntitlementsPerCatalog(input: RequestCatalogManagementServiceListEntitlementsPerCatalogRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceListEntitlementsPerCatalogRequest, RequestCatalogManagementServiceListEntitlementsPerCatalogResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceListEntitlementsPerCatalogRequest, RequestCatalogManagementServiceListEntitlementsPerCatalogResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListEntitlementsPerApp
     */
    listEntitlementsPerApp(input: RequestCatalogManagementServiceListEntitlementsPerAppRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceListEntitlementsPerAppRequest, RequestCatalogManagementServiceListEntitlementsPerAppResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceListEntitlementsPerAppRequest, RequestCatalogManagementServiceListEntitlementsPerAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAllEntitlementIdsPerApp
     */
    listAllEntitlementIdsPerApp(input: RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest, RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest, RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateAppEntitlements
     */
    updateAppEntitlements(input: RequestCatalogManagementServiceUpdateAppEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceUpdateAppEntitlementsRequest, RequestCatalogManagementServiceUpdateAppEntitlementsResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceUpdateAppEntitlementsRequest, RequestCatalogManagementServiceUpdateAppEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List visibility bindings (access entitlements) for a catalog.
     *
     * @generated from protobuf rpc: ListEntitlementsForAccess
     */
    listEntitlementsForAccess(input: RequestCatalogManagementServiceListEntitlementsForAccessRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceListEntitlementsForAccessRequest, RequestCatalogManagementServiceListEntitlementsForAccessResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceListEntitlementsForAccessRequest, RequestCatalogManagementServiceListEntitlementsForAccessResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a catalog.
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: RequestCatalogManagementServiceDeleteRequest, options?: RpcOptions): UnaryCall<RequestCatalogManagementServiceDeleteRequest, RequestCatalogManagementServiceDeleteResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogManagementServiceDeleteRequest, RequestCatalogManagementServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get bundle automation
     *
     * @generated from protobuf rpc: GetBundleAutomation
     */
    getBundleAutomation(input: GetBundleAutomationRequest, options?: RpcOptions): UnaryCall<GetBundleAutomationRequest, BundleAutomation> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBundleAutomationRequest, BundleAutomation>("unary", this._transport, method, opt, input);
    }
    /**
     * Bulk get bundle automations
     *
     * @generated from protobuf rpc: BulkGetBundleAutomations
     */
    bulkGetBundleAutomations(input: BulkGetBundleAutomationsRequest, options?: RpcOptions): UnaryCall<BulkGetBundleAutomationsRequest, BulkGetBundleAutomationsResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkGetBundleAutomationsRequest, BulkGetBundleAutomationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetBundleAutomation
     */
    setBundleAutomation(input: SetBundleAutomationRequest, options?: RpcOptions): UnaryCall<SetBundleAutomationRequest, BundleAutomation> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetBundleAutomationRequest, BundleAutomation>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ForceRunBundleAutomation
     */
    forceRunBundleAutomation(input: ForceRunBundleAutomationRequest, options?: RpcOptions): UnaryCall<ForceRunBundleAutomationRequest, ForceRunBundleAutomationResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<ForceRunBundleAutomationRequest, ForceRunBundleAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ResumePausedBundleAutomation
     */
    resumePausedBundleAutomation(input: ResumePausedBundleAutomationRequest, options?: RpcOptions): UnaryCall<ResumePausedBundleAutomationRequest, ResumePausedBundleAutomationResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<ResumePausedBundleAutomationRequest, ResumePausedBundleAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateBundleAutomation
     */
    createBundleAutomation(input: CreateBundleAutomationRequest, options?: RpcOptions): UnaryCall<CreateBundleAutomationRequest, BundleAutomation> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateBundleAutomationRequest, BundleAutomation>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteBundleAutomation
     */
    deleteBundleAutomation(input: DeleteBundleAutomationRequest, options?: RpcOptions): UnaryCall<DeleteBundleAutomationRequest, DeleteBundleAutomationResponse> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteBundleAutomationRequest, DeleteBundleAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateAppDefaultCatalog
     */
    createAppDefaultCatalog(input: CreateAppDefaultCatalogRequest, options?: RpcOptions): UnaryCall<CreateAppDefaultCatalogRequest, RequestCatalogManagementServiceGetResponse> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAppDefaultCatalogRequest, RequestCatalogManagementServiceGetResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.requestcatalog.v1.RequestCatalogOwnersService
 */
export interface IRequestCatalogOwnersServiceClient {
    /**
     * @generated from protobuf rpc: List
     */
    list(input: RequestCatalogOwnersServiceListRequest, options?: RpcOptions): UnaryCall<RequestCatalogOwnersServiceListRequest, RequestCatalogOwnersServiceListResponse>;
    /**
     * @generated from protobuf rpc: Add
     */
    add(input: RequestCatalogOwnersServiceAddRequest, options?: RpcOptions): UnaryCall<RequestCatalogOwnersServiceAddRequest, RequestCatalogOwnersServiceAddResponse>;
    /**
     * @generated from protobuf rpc: Remove
     */
    remove(input: RequestCatalogOwnersServiceRemoveRequest, options?: RpcOptions): UnaryCall<RequestCatalogOwnersServiceRemoveRequest, RequestCatalogOwnersServiceRemoveResponse>;
}
/**
 * @generated from protobuf service c1.api.requestcatalog.v1.RequestCatalogOwnersService
 */
export class RequestCatalogOwnersServiceClient implements IRequestCatalogOwnersServiceClient, ServiceInfo {
    typeName = RequestCatalogOwnersService.typeName;
    methods = RequestCatalogOwnersService.methods;
    options = RequestCatalogOwnersService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: RequestCatalogOwnersServiceListRequest, options?: RpcOptions): UnaryCall<RequestCatalogOwnersServiceListRequest, RequestCatalogOwnersServiceListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogOwnersServiceListRequest, RequestCatalogOwnersServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Add
     */
    add(input: RequestCatalogOwnersServiceAddRequest, options?: RpcOptions): UnaryCall<RequestCatalogOwnersServiceAddRequest, RequestCatalogOwnersServiceAddResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogOwnersServiceAddRequest, RequestCatalogOwnersServiceAddResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Remove
     */
    remove(input: RequestCatalogOwnersServiceRemoveRequest, options?: RpcOptions): UnaryCall<RequestCatalogOwnersServiceRemoveRequest, RequestCatalogOwnersServiceRemoveResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestCatalogOwnersServiceRemoveRequest, RequestCatalogOwnersServiceRemoveResponse>("unary", this._transport, method, opt, input);
    }
}
